<template>
  <div>
    <!--logo-->
    <div class="w-100"><img src="/images/public/pige/logo.png" class="w-100" style="max-height: 600px"></div>

    <!--content-->
    <div class="w-75 d-flex flex-column m-auto p-5 bg-white" style="min-width: 1200px">
      <!--content-top-->
      <div class="d-flex flex-column text-left">
        <h1 class="font-weight-bold" style="letter-spacing: 0.5rem;color: #919191">浙北皮革城</h1>
        <div class="d-flex flex-column">
          <h3 class="font-color p-2">地 / 址</h3>
          <div class="ml-2" style="height: 0.5rem;width: 2rem;background-color: #616161"></div>
        </div>
        <p class="pt-4 h5 pb-5">浙北皮革城位于浙江省桐乡市，地处沪杭高速屠甸出口处。是进入桐乡市和海宁市的主要门户，总建筑面积约10万平方米。</p>
        <div class="d-flex justify-content-around w-100">
          <img ref="father" class="w-32" src="/images/public/pige/ad01.png">
          <img class="w-32" src="/images/public/pige/ad02.png">
          <img class="w-32" src="/images/public/pige/ad03.png">
        </div>
      </div>

      <!--divider-->
      <div class="d-flex" style="margin-top: 6rem;margin-bottom: 5rem">
        <div class="divider" style="width: 80%"></div>
        <div class="ml-5 divider"></div>
        <div class="ml-3 divider"></div>
        <div class="ml-5 divider" style="width: 15%;"></div>
      </div>

      <!--content-middle-->
      <div class="d-flex flex-column text-left">
        <h2 class="font-color font-weight-bold pb-3">浙北皮革城简介</h2>
        <p class="font-color h5" style="line-height: 2.5rem">
          浙北皮革城：聘请国际专业知名的设计公司，历时一年多的规划设计和论证，采纳专业卖场设计人士的建议，听取众多商家的想法，吸取资深旅游界人士的意见……力争设计上做到领先，时尚。只为追求完美，用一切创造完美。浙北旅游购物中心因地制宜，将茅盾、丰子恺、钱君陶等地方名人文化引人到景观设计中，不仅带给消费者购物享受，更是从精神层面上让消费者更多地了解浙北文化。购物中心的自然景观建设和配套服务，按照4A级景区的标准规划建设，购物和旅游文化完美结合。
        </p>
        <div class="pt-3 d-center">
          <div class="intro-bg p-0">
            <img id="img" src="/images/public/pige/ad04.png" style="width: 100%;height: 100%;display: block">
          </div>
          <div id="content" class="d-center flex-column bg-base text-center m-auto" style=";width: 30%; z-index: 2;">
            <div class="mb-1 d-flex flex-column justify-content-center" style="height: 100%">
              <h3 class="pt-3 font-color font-weight-bold"> 采购商停靠政策</h3>
              <p class="h5">1.5小时，成人15元</p>
              <p class="h5">2.5小时，成人25元</p>
              <p class="h5">3小时，成人30元</p>
              <p class="h5">补助停车费150/80元</p>
            </div>
            <hr class="w-70 m-auto" color="white"/>
            <div class="d-flex flex-column justify-content-center" style="height: 100%">
              <h3 class="font-color font-weight-bold">业务联系</h3>
              <p class="h5">吴小洁/手机（微信）</p>
              <p class="h5">13819330100</p>
            </div>
          </div>
        </div>
        <h2 class="font-color font-weight-bold pt-5">旅游线路
          <span style="font-weight: normal" class="h3"> — — 游乌镇，逛桐乡浙北皮革城-直达约15公里</span>
        </h2>
      </div>

      <!--divider-->
      <div class="d-flex" style="margin-top: 5rem;margin-bottom: 5rem">
        <div class="divider" style="width: 80%"></div>
        <div class="ml-5 divider"></div>
        <div class="ml-3 divider"></div>
        <div class="ml-5 divider" style="width: 15%;"></div>
      </div>

      <!--content-bottom-->
      <div class="d-flex align-items-center">
        <div class="w-50 font-color d-flex flex-column text-left h5">
          <div class="w-75 pb-3">
            <h2 class="font-weight-bold">浙北皮革城专线推介</h2>
            <div class="mt-3" style="height: 0.2rem;width: 6rem;background-color: #919191"></div>
          </div>
          <p class="font-weight-bold pt-3">（1）客人礼品：酱鸭一只、年糕3斤，油面筋20个、洗衣液1斤、果汁1斤</p>
          <p class="font-weight-bold ">（2）建议零售价78元/人，地接价30元/人（含礼品和中餐）</p>
          <p class="pt-5">早上9点到达桐乡浙北皮革城自由购物活动（2小时）</p>
          <p>11点中餐,12：00参观竹炭生活馆（40分钟）</p>
          <p>13：00后车赴嘉善，参观嘉善木雕城（1.5小时）</p>
          <p>15：30参观西塘孔雀城（1小时）</p>
        </div>
        <div class="w-50">
          <img src="/images/public/pige/ad05.png" class="w-100" style="height: 100%">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'LeatherCity',
    data() {
      return {
        timer:null,
      }
    },
    mounted() {
      window.onresize = this.setHeight();
      window.onload = this.setHeight();
    },
    methods:{
      setHeight() {
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          let img = document.getElementById('img');
          let content = document.getElementById('content');
          content.style.height = img.offsetHeight * 0.8 + 'px';
        }, 200);
      },
    }
  }
</script>
<style lang="scss" scoped>
  .w-32 {
    width: 32%;
    height: 100%;
  }

  .divider {
    width: 1%;
    height: 0.2rem;
    background-color: rgba(60, 60, 60, .2);
  }

  .font-color {
    color: #919191;
  }

  .intro-bg {
    box-shadow: 10px 10px 15px rgba(0, 0, 0, 0.3);
    width: 70%;
    z-index: 4;
  }
</style>
